import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {AreaSearchLazy} from "@containers/map/containers/areaSearch/AreaSearch.lazy";

const AreaSearchPage = () => {
    return (
        <PageLayout>
            <Suspense fallback={<SpinnerCustom/>}>
                <AreaSearchLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default AreaSearchPage;